import { Link } from 'react-router-dom'
import { Panel } from '../components/ui/Panel'

export function NotFound() {
  return (
    <Panel title="404">
      <p className="text-sm text-crt-gray">
        no such route<span className="cursor-blink" />
      </p>
      <p className="mt-3 text-xs text-crt-dim">
        <Link to="/" className="text-crt-lime underline underline-offset-2">
          return to overview
        </Link>
      </p>
    </Panel>
  )
}
